import styles from "@/styles/filterBar.module.scss"
import featuredSectionApi from '@/service/modules/featuredSectionApi'
import { useEffect, useState } from "react"
import { Skeleton } from "antd"
import GoogleADSense from "@/components/GoogleADSense"
import ListSvg from '@/svgs/list.svg'
import { fillterBarDictionary } from "@/utils/dictionary"
interface DAMNU_ENABLE {
  [key: string]: any, // 字段扩展声明
}

interface Props {
  type: string;
  onChange: Function;
  filterBarData: DAMNU_ENABLE;
}

export default function FilterBar({ type, onChange, filterBarData }: Props) {

  useEffect(() => {
    getSidebarFilter(type)
  }, [type])

  const [filterBar, setFilterBar] = useState({ sidebarFilter: [] })

  const getSidebarFilter = async (type: string) => {
    try {
      const res = await featuredSectionApi.getSidebarFilter(type)
      const filterBarObject = res.data
      setFilterBar(filterBarObject);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className={styles['filterBar-box']}>
      <div className={styles['filterBar-title']}>
        <ListSvg style={{ width: "28px", height: "28px" }} />
        <span>Sort by</span>
      </div>
      <div className={styles['filterBar-list']}>
        {
          filterBar.sidebarFilter.length > 0
            ?
            filterBar.sidebarFilter.map((item: any, index: number) => {
              // 字典ID
              const dictionary = fillterBarDictionary.getValueByKey(item.key)
              if (item.items.length) {
                return (
                  <div className={styles['filterBar——item']} key={index}>
                    <div className={styles['filterBar——item_label']}>{item.title}</div>
                    <div className={styles['filterBar——item_content']}>
                      {
                        item.items.map((subItem: any, subIndex: number) => {
                          let isActive = false
                          // 判断筛选数据是否存在该值
                          if (filterBarData[item.key]) {
                            // 字典为1 custom-filtering时候需要特殊处理
                            if (dictionary === 1) {
                              isActive = filterBarData[item.key].description === subItem.description
                            } else {
                              isActive = filterBarData[item.key].name === subItem.name
                            }
                          }
                          return (
                            <div
                              className={`${styles['sortItem']} ${isActive && styles['active']}`}
                              onClick={() => { onChange({ key: item.key, ...subItem }) }}
                              key={subIndex}
                            >
                              {
                                // 字典为1 custom-filtering时候需要特殊处理
                                dictionary === 1
                                  ?
                                  `${subItem.name} ${subItem.description && `(${subItem.description})`}`
                                  :
                                  subItem.name
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                )
              }
            })
            :
            <div style={{ padding: "20px" }}>
              <Skeleton active />
            </div>
        }
      </div>
      <GoogleADSense />
    </div >
  )
}